$(document).ready(function () {
    const itemsToShow = 4;
    const listItems = $('.project-description li');
    const viewMoreButton = $('.view-more');

    // Initially hide all items beyond the first set of 4
    listItems.slice(itemsToShow).hide();

    // Check if there are more items than the initial set
    if (listItems.length > itemsToShow) {
        viewMoreButton.show();
    }

    // Set ARIA attributes on the button for accessibility
    viewMoreButton.attr({
        'aria-expanded': 'false',
        'aria-controls': 'description-list'
    });

    // View more button show/hide setup
    viewMoreButton.on('click', function() {
        if (viewMoreButton.hasClass('show')) {
            listItems.slice(itemsToShow).slideUp();
            viewMoreButton
                .removeClass('show')
                .text('View More')
                .attr('aria-expanded', 'false');
        } else {
            listItems.slideDown();
            viewMoreButton
                .addClass('show')
                .text('View Less')
                .attr('aria-expanded', 'true');
        }
    });
});
